import { Apps, App, AppAccess, isApps } from 'core/types/app';

import manage from './manage';
import share from './share';
import clock from './clock';
import calendar from './calendar';
import videos from './videos';
import contentpackages from './contentpackages';

const availableApps: Record<Apps, App> = {
  manage,
  share,
  calendar,
  clock,
  videos,
  contentpackages,
};

export default availableApps;

export function appsWithAccess(access: AppAccess): App[] {
  const apps = Object.keys(availableApps).filter(id => {
    if (!isApps(id)) return false;
    return access[id].role !== 'none' && access[id].enabled;
  });

  return apps.map(id => {
    if (!isApps(id)) throw new TypeError(`Unknown app id: ${id}`);
    return availableApps[id];
  });
}

export function enabledApps(access: AppAccess): App[] {
  const apps = Object.keys(availableApps).filter(id => {
    if (!isApps(id)) return false;
    return access[id].enabled;
  });

  return apps.map(id => {
    if (!isApps(id)) throw new TypeError(`Unknown app id: ${id}`);
    return availableApps[id];
  });
}
